import { Flex } from "antd";
import "@/styles/components/mentorApply.scss";
import ButtonComponent from "@/components/button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserInfo,
  setCurrentForm,
  setModalOpen,
  setFormProps,
  getIsLoggedIn,
} from "@/reducers/commonSlice";
import { useEffect, useState } from "react";
import SEOHead from "@/components/SEO/SEOHead";

const MentorApply = () => {
  const dispatch = useDispatch();
  const userData = useSelector(getUserInfo);
  const [isMobile, setIsMobile] = useState(false);
  const isLoggedIn = useSelector(getIsLoggedIn);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1180);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onApplyForGuide = () => {
    console.log("userData", userData);

    const isGuide = !!userData?.roles?.find((role) => role.name === "Guide");

    if (!isLoggedIn) {
      dispatch(setModalOpen(true));
      dispatch(setCurrentForm("requestOTP"));
      return;
    }

    if (userData?.stage === "Already at university") {
      dispatch(setCurrentForm("applyForGuide"));
      console.warn("applyForGuide");
    } else if (isGuide) {
      dispatch(setCurrentForm("mentorApplicationDescription"));
      dispatch(setFormProps({ isGuide }));
      console.warn("mentorApplicationDescription 1");
    } else {
      console.warn("mentorApplicationDescription 2");
      dispatch(setCurrentForm("mentorApplicationDescription"));
      dispatch(setFormProps({ isGuide: false }));
    }
    dispatch(setModalOpen(true));
  };

  const verificationList = [
    "Soft copy of your Student ID or Visa",
    "Proof of enrollment or university acceptance letter",
    "Government-issued ID (passport, driver's license, etc.)",
    "Your latest academic transcript (optional)",
  ];

  // SEO metadata for Mentor Apply page
  const seoTitle = "Become a Mentor | Join Our Guide Network | Inforens";
  const seoDescription =
    "Share your knowledge and experience by becoming a mentor at Inforens. Help international students navigate their education journey and make a difference in their lives.";
  const seoKeywords =
    "become a mentor, education guide, international student mentor, university guide, study abroad mentor, Inforens mentor, education consultant";

  // Base URL for SEO tags
  const baseUrl = import.meta.env.VITE_URL || window.location.origin;
  const pageUrl = `${baseUrl}/mentor-apply`;

  return (
    <>
      <SEOHead
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        ogTitle={seoTitle}
        ogDescription={seoDescription}
        ogImage={`${baseUrl}/assets/images/mentor-apply-banner.jpg`}
        ogUrl={pageUrl}
        ogType="website"
      />
      <div className="mentorapply component-padding-wrapper">
        {isMobile ? (
          <div className="main-container">
            <div className="content-wrapper">
              <img
                src="/assets/images/person.png"
                className="personimageMobile"
                alt=""
              />
              <div className="left-section">
                <h1 className="title">
                  <span style={{ color: "black" }}>Are you an</span>
                  <br /> international student?
                </h1>
                <p className="subtitle">
                  Become a <b>Mentor with Inforens</b> and help aspiring students
                  achieve their dream of studying abroad by sharing your{" "}
                  <span style={{ color: "#be530b" }}>
                    journey, insights, and valuable experiences!
                  </span>
                </p>
                <ButtonComponent
                  type="primary"
                  label="Apply Now"
                  onClick={onApplyForGuide}
                />
              </div>
              <div className="right-section">
                <p style={{ fontSize: "22px" }}>
                  We'll collect a few simple details to verify you as a mentor.
                  Rest assured, all information is kept strictly confidential.
                </p>
                <ol className="verification-list">
                  {verificationList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        ) : (
          <div className="mainscreenhome">
            <div className="mainscreenhome-body">
              <div className="cardone">
                <img src="/assets/images/person.png" className="personimage" alt="" />

                <div className="cardone-body">
                  <Flex vertical align="end">
                    <div className="contentMentor">
                      <h4 className="t1">Are you an</h4>
                      <h4 className="t2">international student?</h4>
                      <p className="tpara">
                        Become a{" "}
                        <span className="tparas1">Mentor with Inforens</span> and help
                        aspiring students achieve their dream of studying abroad by
                        sharing your{" "}
                        <span className="tparas2">
                          journey, insights, and valuable experiences!
                        </span>
                      </p>
                    </div>
                    <ButtonComponent
                      type="primary"
                      label="Apply Now"
                      onClick={() => onApplyForGuide()}
                    />
                  </Flex>
                </div>
                <div className="card2">
                  <h5>
                    We'll collect a few simple details to verify you as a mentor.
                    Rest assured, all information is kept strictly confidential.
                  </h5>
                </div>
                <div className="bulletgroup">
                  <div className="bullettext">
                    <Flex
                    // justify="center"
                    align="center"
                    gap={10}
                    >
                      <div className="bullet">
                        <span>1</span>
                      </div>
                      <p>Soft copy of your Student ID or Visa</p>
                    </Flex>
                  </div>
                  <div className="bullettext">
                    <Flex
                    // justify="center"
                    align="center"
                    gap={10}
                    >
                      <div className="bullet">
                        <span>2</span>
                      </div>
                      <p>Soft copy of your CV or Resume</p>
                    </Flex>
                  </div>
                  <div className="bullettext">
                    <Flex
                    // justify="center"
                    align="center"
                    gap={10}
                    >
                      <div className="bullet">
                        <span>3</span>
                      </div>
                      <p>University name and email</p>
                    </Flex>
                  </div>
                  <div className="bullettext">
                    <Flex
                    // justify="center"
                    align="center"
                    gap={10}
                    >
                      <div className="bullet">
                        <span>4</span>
                      </div>
                      <p>Your course details</p>
                    </Flex>
                  </div>
                </div>
                {/* <div
                  className="info-box"
                  style={{
                    maxWidth: "100%",
                    marginTop: "2rem",
                    marginRight: "6rem",
                  }}
                >
                  <p className="info-text" style={{ marginBottom: 16 }}>
                    We'll collect a few simple details to verify you as a mentor.
                    <strong>
                      Rest assured, all information is kept strictly confidential.
                    </strong>
                  </p>
                  <ul className="info-list" style={{ marginLeft: "2rem" }}>
                    <li>Soft copy of your Student ID or Visa</li>
                    <li>Soft copy of your Student ID or Visa</li>
                    <li>Soft copy of your Student ID or Visa</li>
                    <li>Soft copy of your Student ID or Visa</li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MentorApply;
